import { Flex, H1WithBack, PageWrapper } from 'styling/GlobalStyles'

import { NavBar } from 'components/NavBar/NavBar'
import { StepNumber } from 'pages/Accomodation/Accommodation.style'
import { BodyText } from 'styling/Typography'
import { NextIcon } from 'pages/Accomodation/icons/NextIcon'
import { useState } from 'react'
import { Identity } from './Sections/Identity'
import { Scope } from './Sections/Scope'
import { Recurrence } from './Sections/Recurrence'
import { Bindings } from './Sections/Bindings'
import { Review } from './Sections/Review'
import { IShiftProgramState } from 'types/operationShiftPrograms.interface'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { useNavigate } from 'react-router-dom'
import { addShiftProgram } from 'features/operations/shiftProgramsSlice'


export const AddShiftProgram = () => {
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()

    const [state, setState] = useState<IShiftProgramState>({
        name: null,
        notes: null,
        site: null,
        teams: [],
        frequencyType: 'everyShift',
        daysOfWeek: [],
        customIntervalDays: null,
        shifts: [],
        bindings: [],
    })
    const [step, setStep] = useState(1)

    const handleSave = async () => {
        const resp = await dispatch(addShiftProgram(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    const renderStep = () => {
        switch (step) {
            case 1:
                return <Identity state={state} setStep={setStep} setState={setState} />
            case 2:
                return <Scope state={state} setStep={setStep} setState={setState} />
            case 3:
                return <Recurrence state={state} setStep={setStep} setState={setState} />
            case 4:
                return <Bindings state={state} setStep={setStep} setState={setState} />
            case 5:
                return <Review state={state} setStep={setStep} handleSave={handleSave} />
        }
    }



    return <>
        <NavBar />
        <PageWrapper noFooter>
            <H1WithBack arrow title='Add Shift Program' />
            <Flex gap='1rem' center style={{ margin: '2rem 0' }} >
                <Step step={1} name='Identity' active={step === 1} onClick={() => setStep(1)} />
                <NextIcon />
                <Step step={2} name='Scope' active={step === 2} onClick={() => setStep(2)} />
                <NextIcon />
                <Step step={3} name='Recurrence' active={step === 3} onClick={() => setStep(3)} />
                <NextIcon />
                <Step step={4} name='Bindings' active={step === 4} onClick={() => setStep(4)} />
                <NextIcon />
                <Step step={5} name='Review' active={step === 5} onClick={() => setStep(5)} />
            </Flex>
            {renderStep()}
        </PageWrapper>
    </>
}

const Step = ({ step, name, active, onClick }: { step: number, name: string, active: boolean, onClick?: () => void }) => {
    return <Flex center gap='1rem' onClick={onClick} style={{ cursor: 'pointer' }} >
        <StepNumber active={active} >  {step}</StepNumber>
        <BodyText grey={!active} >{name}</BodyText>
    </Flex>
}